import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["disabled", "readOnly", "mask", "type", "name", "id", "placeholder", "autoComplete", "maxLength", "autoFocus", "onFocus", "onBlur", "onChange", "onKeyPress", "label", "value", "classes", "theme", "invalid", "namespace"];
import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { getMethodsForTestId } from "../../../utils/getMethodsForTestId";
import { InputBase } from '../../InputBase';
import { FieldLabel } from '../FieldLabel';
import style from './FieldInput.css';
var cx = classNames.bind(style);
export var FieldInput = /*#__PURE__*/forwardRef(function FieldInput(_ref, ref) {
  var disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      mask = _ref.mask,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      name = _ref.name,
      id = _ref.id,
      placeholder = _ref.placeholder,
      autoComplete = _ref.autoComplete,
      maxLength = _ref.maxLength,
      autoFocus = _ref.autoFocus,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onKeyPress = _ref.onKeyPress,
      label = _ref.label,
      value = _ref.value,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'b2c' : _ref$theme,
      invalid = _ref.invalid,
      namespace = _ref.namespace,
      props = _objectWithoutProperties(_ref, _excluded);

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'fieldInput'),
      getTestId = _getMethodsForTestId.getTestId,
      getNamespace = _getMethodsForTestId.getNamespace;

  return /*#__PURE__*/React.createElement("div", _extends({}, getTestId(), {
    className: cx('root', "theme_".concat(theme), {
      invalid: invalid,
      has_label: Boolean(label),
      has_value: Boolean(value)
    }, classes === null || classes === void 0 ? void 0 : classes.inner)
  }, getTestId()), /*#__PURE__*/React.createElement(InputBase, _extends({}, props, {
    className: cx('input', classes === null || classes === void 0 ? void 0 : classes.input),
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: onChange,
    onKeyPress: onKeyPress,
    readOnly: readOnly,
    disabled: disabled,
    placeholder: placeholder,
    type: type,
    value: value,
    mask: mask,
    maxLength: maxLength,
    autoFocus: autoFocus,
    ref: ref,
    name: name,
    autoComplete: autoComplete,
    id: id,
    namespace: getNamespace()
  })), label && /*#__PURE__*/React.createElement(FieldLabel, {
    classes: {
      root: cx('label', classes === null || classes === void 0 ? void 0 : classes.label)
    },
    disabled: disabled,
    invalid: invalid
  }, label));
});